var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "torir-spectrogram" }, [
    _c(
      "div",
      { staticClass: "--plot" },
      [
        _c("AxisY", {
          attrs: { height: _vm.height, min: _vm.freqMin, max: _vm.freqMax }
        }),
        _vm._v(" "),
        _c(
          "div",
          { ref: "scroll", staticClass: "--scroll" },
          [
            _c(
              "div",
              {
                ref: "vbox",
                staticClass: "--vbox",
                style: { height: _vm.height + "px" },
                on: { click: _vm.handleClick }
              },
              [
                _c("div", {
                  staticClass: "--cursor",
                  style: { left: _vm.cursorPosition + "px" }
                }),
                _vm._v(" "),
                _vm.inProgress
                  ? _c("div", { staticClass: "--progress" }, [
                      _vm._v("\n\t\t\t\t\tProcessing...\n\t\t\t\t\t"),
                      _c("div", {
                        staticClass: "--progress-bar",
                        style: { width: _vm.progress + "%" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { ref: "image", staticClass: "--image" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "--markers" },
                  _vm._l(_vm.markers, function(marker) {
                    return _c("MarkerView", {
                      key: marker.id,
                      style: _vm.markerPosition(marker),
                      attrs: { marker: marker }
                    })
                  }),
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("AxisX", {
              attrs: {
                width: _vm.width,
                min: _vm.timeOffset,
                max: _vm.timeOffset + (_vm.duration || 0)
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }